import Modal from "react-bootstrap/Modal";
import verifiedimg from "../../../assets/images/varified.svg";

function AdvertisementConfirmation({ show, handleClose }) {
    return (
        <Modal show={show} className="modal-common delete-pop" onHide={handleClose}>
            <Modal.Body>
                <div className="text-center">
                    <div className="d-flex justify-content-center align-items-center">
                        <img alt="" src={verifiedimg} style={{maxWidth:150}} />
                    </div>
                    <h2 className="mb-3">Successful</h2>
                    <p>
                        Your advertisement request is submitted successfully. Now admin will
                        contact with you.
                    </p>
                        <button onClick={handleClose} className="btn blue-btn">
                            Go to home
                        </button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default AdvertisementConfirmation;
